module.exports = function getResource(label, vars = []) {
    let resources = {
        sephoraCard: 'Carte Sephora',
        sephoraTempCard: 'Carte temporaire Sephora',
        sephoraVisaCard: 'Carte VISA Sephora',
        sephoraVisaTempCard: 'Carte temporaire Visa Sephora'
    };

    return resources[label];
};
